import React, { useState, useEffect, useCallback } from "react";
import { NovedadesApi } from "../../api/Novedades/NovedadesApi";

import {
  IconButton,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MaterialotecaPhotoLightbox from "../Materialoteca/MaterialotecaPhotoLightbox";
import NovedadesFeed, { NovedadesDialogTitle } from "./NovedadesFeed";

const Novedades = () => {
  const [novedades, setNovedades] = useState([]);
  const [open, setOpen] = useState(false);
  const [todas, setTodas] = useState([]);
  const [photoLightbox, setPhotoLightbox] = useState(null);

  // 🔄 Cargar solo no vistas
  const loadNuevas = useCallback(async () => {
    try {
      const data = await NovedadesApi.getNuevas();
      setNovedades(data || []);
    } catch (err) {
      console.error("❌ Error cargando novedades:", err);
    }
  }, []);

  // 🔄 Cargar todas
  const loadTodas = useCallback(async () => {
    try {
      const all = await NovedadesApi.getAll();
      const sorted = [...all].sort((a, b) => b.Id - a.Id);

      const idsNuevos = new Set(novedades.map((n) => n.Id));

      const withFlags = sorted.map((item) => ({
        ...item,
        nuevo: idsNuevos.has(item.Id),
      }));

      setTodas(withFlags);
    } catch (err) {
      console.error("❌ Error cargando todas:", err);
    }
  }, [novedades]);

  // 🚀 Primera carga
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      loadNuevas();
    }
  }, [loadNuevas]);

  // 🔔 Escuchar evento global cuando se crea novedad
  useEffect(() => {
    const handleNuevaNovedad = () => {
      loadNuevas();
      if (open) {
        loadTodas();
      }
    };

    window.addEventListener("novedad-creada", handleNuevaNovedad);

    return () => {
      window.removeEventListener("novedad-creada", handleNuevaNovedad);
    };
  }, [loadNuevas, loadTodas, open]);

  const handleOpen = async () => {
    setOpen(true);
    await loadTodas();
  };

  const handleClose = async () => {
    setOpen(false);
    await loadNuevas();
  };

  const handleMarkRead = async (id) => {
    const numericId = Number(id);
    setNovedades((prev) => prev.filter((n) => Number(n.Id) !== numericId));
    setTodas((prev) =>
      prev.map((n) =>
        Number(n.Id) === numericId ? { ...n, nuevo: false } : n,
      ),
    );
    try {
      await NovedadesApi.marcarVista(id);
    } catch (err) {
      console.error("❌ Error al marcar vista:", err);
    }
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <Badge
          badgeContent={novedades.length}
          invisible={novedades.length === 0}
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "#ff0000",
              color: "white",
            },
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <NovedadesDialogTitle />
        </DialogTitle>
        <DialogContent
          dividers
          sx={{ maxHeight: "min(78vh, 820px)", overflowY: "auto" }}
        >
          {open ? (
            <NovedadesFeed
              items={todas}
              preferNuevos={novedades.length > 0}
              onOpenPhoto={setPhotoLightbox}
              onMarkRead={handleMarkRead}
            />
          ) : null}
        </DialogContent>
      </Dialog>

      <MaterialotecaPhotoLightbox
        open={Boolean(photoLightbox)}
        src={photoLightbox?.src}
        alt={photoLightbox?.alt || ""}
        onClose={() => setPhotoLightbox(null)}
        closeAriaLabel="Cerrar imagen"
      />
    </>
  );
};

export default Novedades;
